export default __webpack_public_path__ + "static/media/portfolio-7.14e52d8a.jpg";